(function () {
  'use strict';

  function slugify(str) {
    return (str || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initTOC(wrapper) {
    var contentEl = wrapper.querySelector('[id^="ck-article-body-"]');
    // Both the sidebar TOC and the inline mobile TOC share the "ck-toc-list-" id prefix.
    var tocLists = Array.prototype.slice.call(wrapper.querySelectorAll('[id^="ck-toc-list-"]'));
    var tocNavs  = Array.prototype.slice.call(wrapper.querySelectorAll('.ck-blog-post__toc'));

    if (!contentEl || tocLists.length === 0) return;

    var headings = Array.prototype.slice.call(contentEl.querySelectorAll('h2, h3')).filter(function (h) {
      return h.textContent.replace(/ /g, ' ').trim() !== '';
    });

    if (headings.length === 0) {
      tocNavs.forEach(function (nav) { nav.hidden = true; });
      return;
    }

    var sidebarEl = wrapper.querySelector('.ck-blog-post__sidebar');
    if (sidebarEl) sidebarEl.classList.add('ck-has-toc');

    headings.forEach(function (h, i) {
      var isSub = h.tagName.toLowerCase() === 'h3';

      if (!h.id) {
        h.id = 'ck-' + h.tagName.toLowerCase() + '-' + i + '-' + slugify(h.textContent);
      }

      tocLists.forEach(function (tocListEl) {
        var li = document.createElement('li');
        li.className = 'ck-blog-post__toc-item' + (isSub ? ' ck-blog-post__toc-item--sub' : '');

        var a = document.createElement('a');
        a.className = 'ck-blog-post__toc-link';
        a.href = '#' + h.id;
        a.textContent = h.textContent;

        a.addEventListener('click', function (e) {
          e.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          try { history.replaceState(null, '', '#' + h.id); } catch (_) {}
        });

        li.appendChild(a);
        tocListEl.appendChild(li);
      });
    });

    if (typeof IntersectionObserver === 'undefined') return;

    var links = wrapper.querySelectorAll('.ck-blog-post__toc-link');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (l) { l.classList.remove('is-active'); });
          // Mark the matching link in every TOC list (sidebar + mobile).
          var active = wrapper.querySelectorAll('.ck-blog-post__toc-link[href="#' + entry.target.id + '"]');
          Array.prototype.forEach.call(active, function (l) { l.classList.add('is-active'); });
        });
      },
      { rootMargin: '-10% 0px -75% 0px', threshold: 0 }
    );

    headings.forEach(function (h) { observer.observe(h); });
  }

  function initButtons(wrapper) {
    var contentEl = wrapper.querySelector('[id^="ck-article-body-"]');
    if (!contentEl) return;

    var clean = function (t) { return t.replace(/ /g, ' ').trim(); };

    var links = Array.prototype.slice.call(contentEl.querySelectorAll('a'));
    links.forEach(function (a) {
      // Case 1: markers inside the link — <a>[button]text[endbutton]</a>
      var m = clean(a.textContent).match(/^\[button\]([\s\S]*?)\[endbutton\]$/);
      if (m) {
        a.textContent = m[1].trim();
        a.classList.add('ck-btn', 'button', 'button--primary');
        return;
      }

      // Case 2: markers outside the link — [button]<a>text</a>[endbutton]
      var prev = a.previousSibling;
      var next = a.nextSibling;
      var prevText = prev && prev.nodeType === 3 ? clean(prev.textContent) : '';
      var nextText = next && next.nodeType === 3 ? clean(next.textContent) : '';

      if (prevText === '[button]' && nextText === '[endbutton]') {
        a.classList.add('ck-btn', 'button', 'button--primary');
        prev.parentNode.removeChild(prev);
        next.parentNode.removeChild(next);
      }
    });
  }

  function initFeaturedItemCarousels(wrapper) {
    var carousels = Array.prototype.slice.call(wrapper.querySelectorAll('.ck-featured-item__carousel-wrap'));
    carousels.forEach(function (root) {
      var carousel = root.querySelector('.ck-featured-item__carousel');
      var thumbs   = Array.prototype.slice.call(root.querySelectorAll('.ck-featured-item__thumb-btn'));
      if (!carousel || thumbs.length < 2) return;

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('.ck-featured-item__slide'));
      var thumbsBar = root.querySelector('.ck-featured-item__thumbs-bar');

      function setActive(idx) {
        thumbs.forEach(function (t, i) {
          t.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }

      // Keep the clicked thumbnail in view by nudging the strip when it's
      // near either edge — otherwise thumbnails past the visible strip
      // width are unreachable on mobile since there's no scrollbar.
      function revealThumb(thumb) {
        if (!thumbsBar) return;
        var thumbW    = thumb.offsetWidth + 6;
        var barRect   = thumbsBar.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        var posInBar  = thumbRect.left - barRect.left;
        var barWidth  = barRect.width;

        if (posInBar + thumb.offsetWidth > barWidth - thumbW * 2) {
          thumbsBar.scrollTo({
            left: thumbsBar.scrollLeft + posInBar + thumb.offsetWidth - (barWidth - thumbW * 2),
            behavior: 'smooth'
          });
        } else if (posInBar < thumbW * 2) {
          thumbsBar.scrollTo({
            left: Math.max(0, thumbsBar.scrollLeft + posInBar - thumbW * 2),
            behavior: 'smooth'
          });
        }
      }

      thumbs.forEach(function (thumb, idx) {
        thumb.addEventListener('click', function () {
          slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          setActive(idx);
          revealThumb(thumb);
        });
      });

      if (typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            setActive(slides.indexOf(entry.target));
          });
        }, { root: carousel, threshold: 0.5 });
        slides.forEach(function (s) { observer.observe(s); });
      }
    });
  }

  function initTocScrollbarHover(wrapper) {
    var sidebars = Array.prototype.slice.call(wrapper.querySelectorAll('.ck-blog-post__sidebar'));
    sidebars.forEach(function (sidebar) {
      sidebar.addEventListener('mouseenter', function () {
        sidebar.classList.add('ck-toc-hover');
      });
      sidebar.addEventListener('mouseleave', function () {
        sidebar.classList.remove('ck-toc-hover');
      });
    });
  }

  function initAuthorToggle(wrapper) {
    // There can be two author blocks: the sidebar one and the inline mobile one.
    var btns = wrapper.querySelectorAll('.ck-blog-post__author-summary');
    Array.prototype.forEach.call(btns, function (btn) {
      var toggle = btn.closest('.ck-blog-post__author-toggle');
      if (!toggle) return;
      btn.addEventListener('click', function () {
        var isOpen = toggle.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('[id^="ck-blog-post-"]').forEach(function (wrapper) {
      initTOC(wrapper);
      initButtons(wrapper);
      initFeaturedItemCarousels(wrapper);
      initTocScrollbarHover(wrapper);
      initAuthorToggle(wrapper);

      var sidebarEl = wrapper.querySelector('.ck-blog-post__sidebar');
      var layoutEl  = wrapper.querySelector('.ck-blog-post__layout');
      if (sidebarEl && layoutEl) {
        var hasAuthor = !!sidebarEl.querySelector('.ck-blog-post__author');
        var hasToc    = sidebarEl.classList.contains('ck-has-toc');
        if (!hasAuthor && !hasToc) {
          layoutEl.classList.add('ck-no-sidebar');
        }

        // An inline [mobile_toc] is present → it renders the full sidebar
        // (author + TOC) in place, so hide the real sidebar on mobile.
        var hasMobileToc = !!wrapper.querySelector('[id^="ck-toc-list-mobile-"]');
        if (hasMobileToc) {
          layoutEl.classList.add('ck-has-mobile-toc');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
